import React, { useState } from 'react';
import HikvisionNavbar from './hikvision/HikvisionNavbar';
import HeroSection from './hikvision/HeroSection';
import PositionSection from './hikvision/PositionSection';
import ValueSection from './hikvision/ValueSection';
import CommitmentSection from './hikvision/CommitmentSection';
import ChallengesSection from './hikvision/ChallengesSection';
import ContactSection from './hikvision/ContactSection';
import { content } from './hikvision/content';

const HikvisionPage = () => {
  const [language, setLanguage] = useState('en');
  const currentContent = content[language];

  const navItems = [
    { id: 'hero', label: currentContent.nav.hero },
    { id: 'position', label: currentContent.nav.position },
    { id: 'value', label: currentContent.nav.value },
    { id: 'commitment', label: currentContent.nav.commitment },
    { id: 'challenges', label: currentContent.nav.challenges },
    { id: 'contact', label: currentContent.nav.contact },
  ];

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'zh' : 'en');
  };

  return (
    <div className="min-h-screen bg-white">
      <HikvisionNavbar
        navItems={navItems}
        language={language}
        onLanguageChange={toggleLanguage}
      />

      <HeroSection content={currentContent.hero} />
      <PositionSection content={currentContent.position} />
      <ValueSection content={currentContent.value} />
      <CommitmentSection content={currentContent.commitment} />
      <ChallengesSection content={currentContent.challenges} />
      <ContactSection content={currentContent.contact} />
    </div>
  );
};

export default HikvisionPage;

